import React from 'react';
import NumberFormat from 'react-number-format';

export function MoneyInput({ ...props }) {
  return <NumberFormat thousandSeparator prefix={'$ '} {...props} />;
}
